export const COLUMN_CONFIG = {
  subject: {
    label: 'Subject',
    sortable: true,
    tooltip: null,
    type: 'string'
  },
  sentAt: {
    label: 'Sent At',
    sortable: true,
    tooltip: null,
    type: 'date'
  },
  numDelivered: {
    label: 'Total Sent',
    sortable: true,
    tooltip: null,
    type: 'number'
  },
  clickRate: {
    label: 'Click-Thru Rate',
    sortable: true,
    tooltip: 'Unique Clicks / Sent Emails',
    type: 'number'
  },
  openRate: {
    label: 'Click-To-Open Rate',
    sortable: true,
    tooltip: 'Unique Clicks / Unique Opens',
    type: 'number'
  }
};

export const PAGE_SIZE = 5;

export type SortColumn = 'subject' | 'sentAt' | 'numDelivered' | 'clickRate' | 'openRate';
export type SortOrder = 'asc' | 'desc';